import React from "react"

// Components
import { Link } from "gatsby"

/**
 * @param shipping - shipping
 * @param modifierClass - class for specific style
 * */
const NavCardMenu = ({ shipping, modifierClass }) => {
  /*==============================
        HANDLE COLUMN SIZE
    ===============================*/
  const classList = shipping ? "col-6 col-lg-2 nav-cards--us" : "col-12 col-sm-4 nav-cards--ww"

  return (
    <section className="p--0">
      <div
        className={`row nav-cards no-gutters justify-content-center ${modifierClass ? modifierClass : ""}  ${
          !shipping ? "flex-column flex-sm-row" : ""
        }`}
      >
        <div className={classList}>
          <div className="nav-card">
            <Link to="/category/workout-plans/" className="nav-card__button" activeClassName="active">
              workout plans
            </Link>
          </div>
        </div>

        <div className={classList}>
          <div className="nav-card">
            <a
              href="https://shop.thebettyrocker.com/rock-your-life/"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-card__button"
            >
              rock your life
            </a>
          </div>
        </div>

        <div className={classList}>
          <div className="nav-card">
            <Link to="/category/meal-plans/" className="nav-card__button" activeClassName="active">
              meal plans
            </Link>
          </div>
        </div>

        {shipping && (
          <div className={classList}>
            <div className="nav-card">
              <Link to="/category/supplements/" className="nav-card__button" activeClassName="active">
                supplements
              </Link>
            </div>
          </div>
        )}

        {shipping && (
          <div className={classList}>
            <div className="nav-card">
              <Link to="/category/merchandise/" className="nav-card__button" activeClassName="active">
                merchandise
              </Link>
            </div>
          </div>
        )}

        {shipping && (
          <div className={classList}>
            <div className="nav-card">
              <Link to="/category/apparel/" className="nav-card__button" activeClassName="active">
                apparel
              </Link>
            </div>
          </div>
        )}
      </div>
    </section>
  )
}

export default NavCardMenu
